import React from 'react';
import { CardHeader } from '@/components/ui/card';
import SearchInput from '@/components/ui/SearchInput';
import AgentMetricsExportButton from './AgentMetricsExportButton';
import InfoTooltip from '@/components/ui/InfoTooltip';

interface AgentMetricsTableHeaderProps {
  title?: string;
  tooltip?: string;
  searchTerm?: string;
  onSearchChange?: (searchTerm: string) => void;
  startDate?: string;
  endDate?: string;
  agentIds?: string[];
}

export const AgentMetricsTableHeader: React.FC<AgentMetricsTableHeaderProps> = ({
  title = 'Agent Metrics Detail',
  tooltip = 'The overview of the call activities for each agent within their assigned Call Queue or their direct line.',
  searchTerm = '',
  onSearchChange,
  startDate,
  endDate,
  agentIds = [],
}) => {
  return (
    <CardHeader className="flex flex-row justify-between gap-2 border-b rounded-t-lg">
      <div className="flex items-center gap-2">
        <span className='capitalize'>{title}</span>
        <InfoTooltip content={tooltip} />
      </div>
      <div className="flex items-center gap-2">
        {onSearchChange && (
          <SearchInput
            placeholder="Search agents..."
            onSearch={onSearchChange}
            initialValue={searchTerm}
          />
        )}
        <AgentMetricsExportButton startDate={startDate} endDate={endDate} agentMicrosoftIds={agentIds} />
      </div>
    </CardHeader>
  );
};
